import { useEffect } from 'react';
import type {
  HydrogenNetworkPointOrBundle,
  PaginatedData,
  HydrogenNetworkPointOrBundleSearchParams,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: HydrogenNetworkPointOrBundleSearchParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: HydrogenNetworkPointOrBundleSearchParams;
} & UrlTemplate;

export function useHydrogenNetworkPointsOrBundles({ url, params }: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<PaginatedData<HydrogenNetworkPointOrBundle>>({
        ...baseConfig,
        url,
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  return request;
}

export type HydrogenNetworkPointsOrBundlesRequest = ReturnType<
  typeof useHydrogenNetworkPointsOrBundles
>;
